<template>
    <div class="home_wrapper">
        <!-- S 顶部导航栏 -->
        <div class="header_wrap" ref="headRef" :style="{backgroundColor: `rgba(${bgHandle(forum.theme_color)}, ${headerOpacity})`}">
            <div class="head_lt animate__fadeIn animate __animated" v-if="headerOpacity < 0.5">
                <div class="search" @click="goSearchPage">
                    <div class="img">
                        <img src="@/assets/images/find/icon_find.png"/>
                    </div>
                    <div class="text">点击搜索</div>
                </div>
            </div>
            <div class="head_lt_end animate__fadeIn animate__animated" v-else>
                <div class="search" @click="goSearchPage">
                    <div class="img">
                        <img src="@/assets/images/find/icon_find.png"/>
                    </div>
                    <div class="text">点击搜索</div>
                </div>
                <!-- <span class="head_lt_main van-ellipsis">{{forum.name || ''}}</span>
                <img class="switch_icon" @click="interestListShowPop" v-if="!(sdkInfo.isSdkEnv)" src="../../assets/images/atmosphere/icon_switch.png" alt="全部圈子"> -->
            </div>

            <head-icon></head-icon>
        </div>
        <!-- E 顶部导航栏 -->

        <!-- S 顶部底层 -->
        <div class="bottom_wrap" ref="infoRef" :style="{transform: `translateY(${toolBgDistance}px)`}">
            <!-- 背景 -->
            <div class="bg_img" :style="{height: toolBgHeight + 'px'}">
                <img :src="forum.cover" alt="">
                <div class="bg_layer" :style="{backgroundColor: forum.theme_color}"></div>
                <div class="bg_layer_up"></div>
            </div>

            <div class="thread_choose">
                <div class="vip_game_container">
                    <div class="vip_game_scroll">
                        <ul class="vip_game_list">
                            <li
                                :class="[
                                    'vip_game_item',
                                    v && v.id == forum.id && 'active',
                                ]"
                                v-for="v in threadList"
                                :key="v.id"
                                @click.stop="switchCircle(v.id)"
                            >
                                <img style="border-radius: 10px;" :src="v.icon" alt="" />
                            </li>
                        </ul>
                    </div>
                    <div class="vip_game_select_btn" @click="isShowSelectGamePopup = true">
                        <li
                            class="vip_game_item vip_game_item_self"
                        >
                            <span>选择</span><span>游戏</span>
                        </li>
                    </div>
                </div>
            </div>

            <!-- 圈子简要信息 -->
            <div class="atmosphere_wrap">
                <!-- <div class="atmosphere_icon" :style="{transform: `scale(${circleScale})`}" @click="forum.game_id != 0 ? goState({name: 'gamedetail', params: {gameid: forum.game_id}}) : ''">
                    <img :src="forum.icon" alt="">
                </div> -->
                <div class="atmosphere_icon" :style="{transform: `scale(${circleScale})`}">
                    <img :src="forum.icon" alt="">
                </div>
                <div class="atmosphere_info">
                    <div class="atmosphere_name van-ellipsis">{{forum.name || ''}}</div>
                    <div class="atmosphere_fragment van-ellipsis">{{forum.subscribed || 0}}成员 | {{forum.threads || 0}}帖子</div>
                </div>
                <div class="atmosphere_follow"  @click="followForum">
                    <img v-if="subscribe" src="../../assets/images/atmosphere/icon_follow_end.png" alt="">
                    <img class=" animate__swing animate__animated animate__delay-2s" v-else src="../../assets/images/atmosphere/icon_follow.png" alt="">
                </div>
            </div>

            <!-- 工具栏 -->
            <div ref="toolsRef">
                <div v-if="showcolumnTab" class="tools_wrap">
                    <div class="tools_list" :style="{opacity: toolsOpacity}">
                        <Swipe class="cloum_swipe" :show-indicators="true" :loop="false" :stop-propagation ="false" :touchable="true">
                            <template v-if="forum_column&&forum_column.length>0">
                                <SwipeItem v-for="(v, i) in Math.ceil(forum_column.length/4)" :key="i">
                                    <div class="cloum_list">
                                        <div class="cloum_item" v-for="item in forum_column.slice(i*4, 4 + i * 4)" :key="item.id" @click.stop="util.clickStat('circle_click_menu', {menu_id: item.id, menu_name: item.name, url: item.link});jumpPage(item)">
                                            <img :src="item.icon" alt="">
                                            <div class="item_name van-ellipsis">{{item.name}}</div>
                                        </div>
                                    </div>
                                </SwipeItem>
                            </template>
                        </Swipe>
                    </div>
                </div>
            </div>

            <!-- 活动 -->
            <div class="activity" v-if="activityList.length > 0">
                <Swipe class="my-swipe" :autoplay="3000" :stop-propagation="true">
                    <SwipeItem v-for="v in activityList" :key="v.id">
                        <img :src="v.banner" alt="" @click="handleCLickActivity(v)">
                    </SwipeItem>
                </Swipe>
            </div>

            <!-- 资讯 -->
            <div v-if="!isExpanded" ref="newsRef" class="news_notice_bar">
                <NoticeBar :scrollable="false" background="#ffffff" :style="{ opacity: newsOpacity }" v-if="latestNews.length > 0">
                    <Swipe vertical class="notice-swipe" :autoplay="3000" :touchable="false"
                        :show-indicators="false" :stop-propagation="false">
                        <SwipeItem v-for="v in latestNews.slice(0, 5)" :key="v.tid">
                            <div class="news_item" @click="clickStat({id: v.tid, is_announce: '0'});goState({ name: 'forumdetail', params: { id: v.tid }, query: {is_announce: '0'} })">
                                <div class="item_lt">
                                <Tag type="primary" text-color="#fff" color="#E44D42" size="medium">{{ v.top_tag ||
                                    '' }}
                                </Tag>
                                <div class="news_txt van-ellipsis">{{ v.subject || '' }}</div>
                            </div>
                            <div class="item_rt">{{ v.publish_time ? util.timeHandle(v.publish_time) : '' }}</div>
                            </div>
                        </SwipeItem>
                    </Swipe>
                    <template #right-icon>
                        <div class="new_tit_rt" @click="setExpanded(true)">展开<Icon class="arrow_icon" name="arrow-down" /></div>
                    </template>
                </NoticeBar>
                <span v-else>暂无最新资讯</span>
            </div>
            <div v-if="isExpanded" class="news_wrap" ref="newsRef">
                <div class="news_title" :style="{opacity: newsOpacity}">
                    <div class="new_tit_lt">最新资讯</div>
                    <div class="new_tit_rt" @click="setExpanded(false)">收起<Icon class="arrow_icon" name="arrow-up" /></div>
                </div>

                <div class="news_list" :style="{opacity: newsOpacity}">
                    <div class="news_item" v-for="v in latestNews.slice(0, 5)" :key="v.tid" @click="clickStat({id: v.tid, is_announce: '0'});goState({name:'forumdetail', params: {id: v.tid}, query: {is_announce: '0'}})">
                        <div class="item_lt">
                            <Tag type="primary" text-color="#fff" color="#E44D42" size="medium" >{{v.top_tag || ''}}</Tag>
                            <div class="news_txt van-ellipsis">{{v.subject || ''}}</div>
                        </div>
                        <div class="item_rt">{{v.publish_time ? util.timeHandle(v.publish_time) : ''}}</div>
                    </div>
                </div>
            </div>

            <!-- 超级话题入口 -->
            <div class="super_topic" v-if="superTopicList.length != 0">
                <div class="head">
                    <div class="left">大家都在看</div>
                    <div class="right" @click="expandSuperTopic()" v-if="superTopicList.length > 2">更多>></div>
                </div>
                <div class="content">
                    <div class="topic_item" @click="goTopicPage(v)" v-for="(v, index) in showSuperTopicList" :key="index">
                        <div class="left_box">
                            <img :src="v.icon"/>
                        </div>
                        <div class="right_box">
                            <div class="title">{{v.name}}</div>
                            <div class="num">{{v.views}}浏览</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- E 顶部底层 -->

        <!-- S 帖子内容 -->
        <div class="forum_wrapper" ref="scrollRef">

            <div class="refresh_wrap">
                <span v-if="isRefreshing"><Loading color="#333" size="24px">加载中...</Loading></span>
                <span v-else>{{refreshTxt}}</span>
            </div>

            <div class="tab_wrap taber_wrapper" v-if="showScrollTab">
                <Tabs class="mescroll-touch-x" v-model:active="active" @change="childrenTabChange" swipeable>
                    <Tab v-for="v in subsection" :title="v.name" :key="v.id"></Tab>
                </Tabs>
            </div>

            <div class="sort_select_box">
                <select v-model="selectedOption" @change="sortSelectChange">
                    <option
                        v-for="option in sortOptions"
                        :key="option.value"
                        :value="option.value"
                        :disabled="option.disabled"
                    >
                        {{ option.text }}
                    </option>
                </select>
            </div>

            <div @touchstart="handleTouchStart2($event)" @touchmove="handleTouchMove2($event)" @touchend="handleTouchEnd2($event, v)">
                <div class="forum_item" v-for="v in forumList" :key="v.tid">
                    <forum :clickStat="clickStat" :deleteForum="deleteForum" :isLikesFun="goLike" :forumData="v"></forum>
                </div>

                <empty-status v-if="forumList && forumList.length <= 0"></empty-status>
            </div>

            <div class="refresh_bottom">{{refreshUptxt}}</div>
        </div>
        <!-- E 帖子内容 -->

        <!-- S 子版块 -->
        <div class="tab_wrap" :style="{top: initTabTop + 'px'}" v-if="!showScrollTab">
            <Tabs class="mescroll-touch-x" v-model:active="active" @change="childrenTabChange">
                <Tab v-for="v in subsection" :title="v.name" :key="v.id"></Tab>
            </Tabs>
        </div>

        <div class="tab_wrap top_tab_wrap" v-if="showTopTab">
            <Tabs class="mescroll-touch-x" v-model:active="active" @change="childrenTabChange">
                <Tab v-for="v in subsection" :title="v.name" :key="v.id"></Tab>
            </Tabs>
        </div>
        <!-- E 子版块 -->

    </div>

    <AppDownload></AppDownload>

    <Popup
            :show="isShowSelectGamePopup"
            @closed="closeSelectGamePopup"
            :overlay="true"
            position="bottom"
        >
            <div class="select_game_popup">
                <p class="select_game_popup_title">选择圈子</p>
                <Grid :column-num="4" :border="false" class="select_game_popup_list">
                    <GridItem
                        v-for="(v, i) in allThreadList"
                        :key="v.id"
                        class="select_game_popup_item"
                        @click="selectGame(v, i)"
                    >
                        <div class="select_game_popup_icon">
                            <span class="select_game_popup_select" v-if="v.isSelect"></span>
                            <img :src="v.icon" alt="" />
                        </div>
                        <p class="select_game_popup_name">{{ v.name }}</p>
                    </GridItem>
                </Grid>
                <Button class="select_game_popup_btn" round @click="closeSelectGamePopup"
                    >确定</Button
                >
            </div>
        </Popup>

    <!-- S 全部圈子弹窗 -->
    <Popup v-model:show="showInterestPop" position="bottom" teleport=".home_wrapper">
        <div class="interest_wrap">
            <div class="title">请选择游戏圈子</div>
            <div class="close_btn" @click="hideInterestPop"><img src="../../assets/images/atmosphere/icon_close.png" alt=""></div>
            <div class="list">
                <div class="list_layer">
                    <div class="list_item" v-if="interestList.recent && interestList.recent.length > 0">
                        <div class="subtit">最近访问</div>
                        <div class="grid_wrap">
                            <div class="grid_item" v-for="v in interestList.recent" :key="v.id" @click.stop="switchCircle(v.id)">
                                <img :src="v.icon" :alt="v.name">
                                <div class="txt van-multi-ellipsis--l2">{{v.name}}</div>
                            </div>

                            <div class="grid_item" v-for="(v, i) in (interestList.recent.length % 4 == 0 ? 0 : 4 - interestList.recent.length % 4)" :key="i"></div>
                        </div>
                    </div>

                    <template v-for="(v, i) in interestList.bbs" :key="i">
                        <div class="list_item" v-if="v.bbs && v.bbs.length > 0">
                            <div class="subtit">{{v.group_name}}</div>
                            <div class="grid_wrap">
                                <div class="grid_item" v-for="item in v.bbs" :key="item.id" @click.stop="switchCircle(item.id)">
                                    <img :src="item.icon" :alt="item.name">
                                    <div class="txt van-multi-ellipsis--l2">{{item.name}}</div>
                                </div>

                                <div class="grid_item" v-for="gridItem in (v.bbs.length % 4 == 0 ? 0 : 4 - v.bbs.length % 4)" :key="gridItem"></div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </Popup>
    <!-- E 全部圈子弹窗 -->

    <!-- S 全部资讯窗口 -->
    <Popup v-model:show="showMoreNewsPop" position="bottom" teleport=".home_wrapper">
        <div class="news_more_wrap">
            <div class="title">
                <span>最新资讯</span>
                <div class="close_btn" @click="hideNewsListPop"><img src="../../assets/images/atmosphere/icon_back.png" alt=""></div>
            </div>
            <div class="news_list new_more_list">
                <div class="news_list_layer">
                    <div class="news_item" v-for="v in newsList" :key="v.tid"  @click="clickStat({id: v.tid, is_announce: '0'});goState({name:'forumdetail', params: {id: v.tid}, query: {is_announce: '0'}})">
                        <div class="item_lt">
                            <Tag type="primary" text-color="#fff" color="#E44D42" size="medium" >{{v.top_tag || ''}}</Tag>
                            <div class="news_txt van-ellipsis">{{v.subject || ''}}</div>
                        </div>
                        <div class="item_rt">{{v.publish_time ? util.timeHandle(v.publish_time) : ''}}</div>
                    </div>
                </div>
            </div>
        </div>
    </Popup>
    <!-- E 全部资讯窗口 -->


    <Advertise :showAdvertise="showAdvertise" :advertiseData="advertiseData" :ifCheckbox="ifCheckbox" @checkbox="checkbox" @HaveAdvertise="HaveAdvertise"></Advertise>

    <!-- S 新建帖子 -->
    <Overlay :show="isShowAddForumType" z-index="999" class-name="add_forum_overlay" @click="isShowAddForumType = !isShowAddForumType" />
    <div v-if="forum.allow_post == 1 && forum.group_id != 1 && computerShowEditForum()" class="add_forum" :class="{add_forum_active: isShowAddForumType}">
        <div class="add_type">
            <template v-for="v in addForumTypeList" :key="v.color">
                <div class="add_type_item animate_animated animate__bounceInRight"
                    v-if="v.isUse"
                    :style="{backgroundColor: v.color}"
                    @click="util.clickStat('circle_create_post', {post_type: v.typeName});goState({name: 'editForum', params: {type: v.type, id: forum.id}})">
                    <img class="type_icon" :src="v.icon" />
                    <div class="add_tips">
                        <p>
                            <span class="add_type_name">{{v.typeName}}</span>
                            <span>{{v.title}}</span>
                        </p>
                        <p>
                            {{v.subtitle}}
                        </p>
                    </div>
                </div>
            </template>
        </div>

        <div class="add_btn" @click="isShowAddForumType = !isShowAddForumType">
            <img src="../../assets/images/atmosphere/icon_add.png" alt="">
        </div>
    </div>
    <!-- E 新建帖子 -->

    <!-- 活动弹窗 -->
    <Popup v-model:show="screenPopup" style="background-color: transparent;padding: 10px;">
        <div class="popup_box">
            <Swipe class="my-swipe" :autoplay="3000" :stop-propagation="true">
                <SwipeItem v-for="v in popupList" :key="v.id"
                    @touchstart="handleTouchStart($event)"
                    @touchmove="handleTouchMove($event)"
                    @touchend="handleTouchEnd($event, v)">
                    <img :src="v.images" alt="" />
                </SwipeItem>
            </Swipe>
            <Icon name="close" class="popup_close" @click="closeActivityPop" />
        </div>
    </Popup>
    <!-- 活动弹窗 -->

    <!-- S 底部导航栏 -->
    <tabbar name="index" :goTopBtnShow="goTopBtnShow" :goTopBtnShow2="false" @goTop=goTop></tabbar>
    <!-- E 底部导航栏 -->
</template>

<script lang="js">
import { defineComponent, ref, reactive, toRefs, watch, onBeforeMount, onMounted, onActivated, onDeactivated, computed } from 'vue';
import { Button, Tag, Tab, Tabs, Popup, Grid, GridItem, Overlay, Loading, Dialog, Swipe, SwipeItem, NoticeBar, Icon} from 'vant';
import router from '@/router';
import { onBeforeRouteLeave } from "vue-router";
import { useStore } from 'vuex';
import Util from '@/assets/js/lib/util';
import Tabbar from '@/components/Seven_Tabbar/Tabbar.vue';
import HeadIcon from '@/components/Seven_HeadIcon/HeadIcon.vue';
import Forum from '@/components/Seven_Forum/Forum.vue';
import Advertise from '@/components/Git_Advertise/Advertise.vue';
import videoIcon from "@/assets/images/atmosphere/icon_video.png"
import questionIcon from "@/assets/images/atmosphere/icon_question.png"
import editIcon from "@/assets/images/atmosphere/icon_edit.png"
import BScroll from '@better-scroll/core'
import MouseWheel from '@better-scroll/mouse-wheel'
import Pulldown from '@better-scroll/pull-down'
import Pullup from '@better-scroll/pull-up'
import ObserveImage from '@better-scroll/observe-image'
BScroll.use(MouseWheel)
BScroll.use(Pullup)
BScroll.use(Pulldown)
BScroll.use(ObserveImage)
import EmptyStatus from "@/components/Seven_EmptyStatus/EmptyStatus.vue";
import AppDownload from '@/components/AppDownload/AppDownload.vue';

export default defineComponent({
    name: 'Index',
    components: { Button, Tabbar, HeadIcon, Tag, Tab, Tabs, Forum, Popup, Grid, GridItem, Overlay, Loading, Dialog, EmptyStatus, Swipe, SwipeItem, Advertise, NoticeBar, Icon, AppDownload},
    setup(props, { attrs, slots }) {
        const store = useStore();

        const state = reactive({ //自定义方法
            util: new Util(), //公共库
            sdkInfo: computed(() => store.state.sdkInfo || {}),
            bs: '', //滚动插件的对象
            active: 0, //tab选中的下标
            headerOpacity: 0, //顶部标题的透明度
            newsOpacity: 1, //新闻资讯的透明度
            circleScale: 1,
            scrollRef: '', //tab的节点
            infoRef: '', //圈子信息的节点
            newsRef: '', //最新资讯的节点
            headRef: '', //顶部导航栏节点
            initTabTop: '', //tab的初始值
            page: 1, //当前页数
            total: 1, //总页数
            limit: 10, //每页行数
            showInterestPop: false, //显示全部圈子列表
            showMoreNewsPop: false, //全部咨询的弹窗
            allInterestBs: '', //全部圈子的滚动条
            moreNewsBs: '', //更多资讯的滚动条
            addForumTypeList: [ //新增帖子类型
                {
                    icon: videoIcon,
                    typeName: '视频',
                    title: '我想发视频',
                    subtitle: '记录最精彩的瞬间！',
                    isUse: false,
                    color: '#D197FE',
                    type: 'video',
                    forum_type: 'forum'
                },
                {
                    icon: questionIcon,
                    typeName: '提问',
                    title: '我想问问大家',
                    subtitle: '你是怎么看待的？',
                    isUse: true,
                    color: '#97C3FE',
                    type: 'questions',
                    forum_type: 'forum'
                },
                {
                    icon: editIcon,
                    typeName: '帖子',
                    title: '我要写文章',
                    subtitle: '评论、分析、攻略',
                    isUse: true,
                    color: '#FEC897',
                    type: 'forum',
                    forum_type: 'forum'
                },
                // {
                //     icon: editIcon,
                //     typeName: '短文',
                //     title: '我要写短文',
                //     subtitle: '图文展示',
                //     isUse: true,
                //     color: '#FEC897',
                //     type: 'forum',
                //     forum_type: 'short_forum'
                // },
            ],
            isShowAddForumType: false, //是否显示新建帖子的分类块
            refreshTxt: '', //下拉刷新的文本
            isRefreshing: false, //是否正在刷新中
            refreshUptxt: '加载更多',
            showTopTab: false,
            showScrollTab: true,
            showAdvertise: false, //广告的弹窗
            ifCheckbox: false, //广告下次是否弹出选中框
            userInfo: computed(() => store.state.userInfo),
            toolsRef:'', //工具栏的节点
            toolsOpacity:1, //工具栏的透明度
            showcolumnTab:false, //是否展示工具栏
            toolBgHeight: 500, //工具栏的背景高度
            toolBgDistance: 0, //工具栏的移动距离
            isClickFollowForum: true,
            isExpanded: false,
            sdkInfo: computed(() => store.state.sdkInfo),
            goTopBtnShow: false,
            isShowSelectGamePopup: false,
            counts: 0,
            sortOptions: [
                { value: 'new', text: '最新', disabled: false },
                { value: 'hot', text: '最热', disabled: false }
            ],
            selectedOption: 'hot',
            isLoad: false,
            scrollPosition: 0,
            screenPopup: false,

            handleTouchStart: (event) => {
                state.touchStartTime = new Date().getTime();
                state.touchStartX = event.touches[0].clientX;
                state.touchStartY = event.touches[0].clientY;
            },

            handleTouchMove: (event) => {
                // 阻止默认行为防止滑动冲突
                event.preventDefault();
            },

            handleTouchEnd: (event, item) => {
                const touchEndTime = new Date().getTime();
                const touchEndX = event.changedTouches[0].clientX;
                const touchEndY = event.changedTouches[0].clientY;

                // 计算时间差和位移
                const timeGap = touchEndTime - state.touchStartTime;
                const moveX = Math.abs(touchEndX - state.touchStartX);
                const moveY = Math.abs(touchEndY - state.touchStartY);

                // 如果移动距离小于10px且时间小于200ms,则认为是点击事件
                if (moveX < 10 && moveY < 10 && timeGap < 200) {
                    methods.handleCLickActivity(item);
                }
            },
        });

        const data = reactive({ //页面数据
            subscribe: false, //是否关注圈子
            latestNews: '', //新闻资讯
            forum: '', //圈子信息
            subsection: [], //子版块
            forumList: [], //论坛列表
            interestList: {}, //全部圈子列表
            newsList: [], //全部资讯列表
            forum_column:[],//圈子工具栏列表
            advertiseData: {}, //广告图片
            allThreadList: [], //全部圈子列表
            threadList: [], //圈子实际显示列表
            activityList: [],
            superTopicList: [], //超级话题列表
            showSuperTopicList: [], //展示用的超级话题列表
            popupList: [],
            selectForumIdArr: [], //已打开弹窗的圈子id
        });

        let isMountedRequestCompleted = false;
        let isActivatedRequestCompleted = false;

        // 监听forum
        watch(() => data.forum.id, (newVal, oldVal) => {
            getPopList();
        });

        onMounted(async () => {
            if(router.currentRoute.value.params.id){
                await reqCircleData(router.currentRoute.value.params.id);
            }else if(router.currentRoute.value.query.id){
                await reqCircleData(router.currentRoute.value.query.id);
            }else{
                await reqPageData();
            }
            if(isActivatedRequestCompleted){
                methods.enterStat()
            }
            isMountedRequestCompleted = true;

            await reqSubsection();
            await reqForumList();
            await reqInterestList();
            await reqActivityList();
            await getSuperTopic();
            initPageView();
            setToolBgHeight()
            scrollInit();
            removeIndexDot();
        });

        onActivated(async () => { //当页面再次出现在页面上时候出发事件，只有缓存组件才有
            initDataFun();
            if(state.bs == ''){
                scrollInit();
            }else{
                state.bs.refresh();
                // 恢复滚动位置
                if (state.scrollPosition !== 0) {
                    setTimeout(() => {
                        state.bs.scrollTo(0, state.scrollPosition, 0);
                    }, 300);
                }
            }
            state.showScrollTab = true;
            if(data.forum.id){
                if(router.currentRoute.value.query.id && router.currentRoute.value.query.id != data.forum.id){
                    await reqCircleData(router.currentRoute.value.query.id);
                    setTimeout(() => {
                        state.initTabTop = state.scrollRef.getBoundingClientRect().top;
                    }, 100);
                }else{
                    await reqCircleData();
                }
                await reqSubsection();
                await changeList();
                await getSuperTopic();
            }
            if(isMountedRequestCompleted){
                methods.enterStat()
            }
            isActivatedRequestCompleted = true;
            initPageView();
            // await reqAdvertise();
            setToolBgHeight()

            setTimeout(()=>{
                if(state.bs){
                    state.bs.refresh()
                }
            },500)
        })

        onDeactivated(() => { //页面隐藏时候触发事件
            initDataFun()
            state.screenPopup = false
            if (state.bs) {
                state.scrollPosition = state.bs.y;
            }
            // state.bs.destroy();
        })

        const removeIndexDot = () => {
            //消除圈子未读红点
            //只消除一次
            store.commit('changeIndexDot', false);
        }

        const initDataFun = () => { //初始化一些隐藏操作
            state.showInterestPop = false;
            state.showMoreNewsPop = false;
            state.isShowAddForumType = false;
            state.showAdvertise = false;
        }

        const setToolBgHeight = () => {
            setTimeout(() => {
                state.toolBgHeight = state.headRef.offsetHeight + state.infoRef.offsetHeight + 28
            }, 100)
        };

        const scrollInit = () => { //初始化滚动条
            state.bs = new BScroll('.home_wrapper',{
                click: false,
                probeType: 3,
                // 启用鼠标滚轮插件
                mouseWheel: {
                    speed: 40, // 滚动速度
                    invert: false, // 滚轮方向与滚动方向是否相反
                    dampingFactor: 0.05, // 阻尼系数，用于模拟真实滚动感
                    easeTime: 300 // 动画缓动时间
                },
                bounceTime: 600,
                specifiedIndexAsContent: 2,
                outOfBoundaryDampingFactor: 0.3,
                momentumLimitDistance: 40,
                // directionLockThreshold: 30,  // 添加方向锁定阈值
                eventPassthrough: 'horizontal',  // 水平滑动事件穿透
                pullDownRefresh: {
                    threshold: 50,
                    stop: 40 //这样就会回到顶部了
                },
                pullUpLoad: { //上拉加载
                    threshold: -40
                },
                observeImage: true
            })

            let timeIndex = 0;

            state.bs.on('scroll',  (position) => {
                if(position.y < -1400) {
                    state.goTopBtnShow = true;
                }else {
                    state.goTopBtnShow = false;
                }

                const currentY = Math.abs(position.y); // 当前滚动距离（正数）
                const maxScrollY = Math.abs(state.bs.maxScrollY); // 最大滚动距离（正数）
                const distanceToBottom = maxScrollY - currentY;
                if(distanceToBottom < 1200 && !state.isLoad) {
                    if(state.page <= state.total) {
                        state.isLoad = true;
                        reqForumList(true);
                    }
                }

                timeIndex++;
                // if(timeIndex == 2){ //节流一半
                    timeIndex = 0;

                    if(position.y < 0){
                        state.refreshTxt = '';
                        state.showScrollTab = true;
                    }else if(position.y < 38){
                        state.refreshTxt = '下拉刷新';
                        state.isRefreshing = false;
                        state.bs.finishPullDown();
                        state.showScrollTab = false;
                    }else {
                        state.refreshTxt = '释放刷新';
                        state.showScrollTab = false;
                    };

                    initPageView();
                    if(position.y <= 0) {
                        state.toolBgDistance = position.y
                    }else {
                        state.toolBgDistance = 0
                    }
                // }
            });

            state.bs.on('scrollEnd', () => {
                initPageView();
            })

            state.bs.on('pullingDown', async (position) => {
                state.isRefreshing = true;
                state.page= 1;
                state.total= 1;
                await reqCircleData();
                await reqSubsection();
                await reqForumList();
                await reqInterestList();
                await reqActivityList();
                await getSuperTopic();
                setTimeout(() => {
                    window.Components.toast('刷新成功');
                    state.bs.scrollTo(0, 0);
                    state.bs.finishPullDown();
                    state.bs.finishPullUp();
                    state.bs.refresh();
                    state.initTabTop = state.scrollRef.getBoundingClientRect().top;
                }, 300);
            })

            state.bs.on('pullingUp', async () => {

                if(state.page > state.total){
                    state.refreshUptxt = '暂无更多帖子';
                    return
                }

                state.refreshUptxt= '加载更多';

                // await reqForumList(true);
                // await reqInterestList();
                // await reqActivityList();
                // await getSuperTopic();

                setTimeout(() => {
                    state.bs.finishPullUp();
                    state.bs.refresh();
                }, 300);
            })

            setTimeout(() => {
                state.bs.refresh()
            }, 300);
        };

        const newOpacity = (y, y1) => { //最新资讯透明化的事件，y是获取到内容页滚动区域距离顶部的值，y1是获取顶部导航栏的高度
            let newsHeight = state.newsRef.offsetHeight;
            let newsTop = state.newsRef.getBoundingClientRect().top;
            let opa = ((y - newsTop)/ newsHeight);
            state.newsOpacity = opa < 0 ? 0 : opa > 1 ? 1 : opa;

            if(!state.showcolumnTab){
                if(y <= newsTop){
                    let scale = (y - y1) / 79
                    state.circleScale =  scale > 1 ? 1 : scale < 0 ? 0 : scale
                }else {
                    state.circleScale = 1;
                }
            }

        };

        const toolsOpacity = (y, y1) => { //最新工具透明化的事件，y是获取到内容页滚动区域距离顶部的值，y1是获取顶部导航栏的高度
            let toolsHeight = state.toolsRef.offsetHeight;
            let toolsTop = state.toolsRef.getBoundingClientRect().top;
            let opa = ((y - toolsTop)/ toolsHeight);
            state.toolsOpacity = opa < 0 ? 0 : opa > 1 ? 1 : opa;

            if(y <= toolsTop){
                let scale = (y - y1) / 79
                state.circleScale =  scale > 1 ? 1 : scale < 0 ? 0 : scale
            }else {
                state.circleScale = 1;
            }
        };

        const initPageView = () => { //初始化页面动态效果
            state.counts = state.counts + 1;
            let getOffTop = state.scrollRef.getBoundingClientRect().top; //获取到滚动区域距离顶部的值
            let infoHeight = state.infoRef.offsetHeight; //获取顶部圈子信息的高度
            let headHeight = state.headRef.offsetHeight; //获取顶部导航栏的高度
            let headOpa = (1 - (getOffTop - headHeight)/ infoHeight) < 0 ? 0 : 1 - (getOffTop - headHeight)/ infoHeight;
            if(state.initTabTop == ''){
                state.initTabTop = getOffTop; //存一个初始值
            };

            if(state.counts == 2) {
                state.initTabTop = getOffTop;
            }

            if(getOffTop <= headHeight){
                state.showTopTab = true;
            }else{
                state.showTopTab = false;
            };

            if(headOpa > 1) {
                state.headerOpacity = 1;
            }else {
                state.headerOpacity = headOpa
            }

            newOpacity(getOffTop, headHeight);
            if(state.showcolumnTab){
                toolsOpacity(getOffTop, headHeight);
            }

        };

        const getSuperTopic = async () => {
            //请求圈子的话题列表
            const res = await state.util.getJson('/superTopic', 'GET', {forum_id: data.forum.id}, true);
            if(res.code == 0) {
                data.superTopicList = res.data.supertopics;
                data.superTopicList.sort((a, b) => a.sort - b.sort)
                if(data.superTopicList.length > 2) {
                    data.showSuperTopicList = data.superTopicList.slice(0, 2)
                }else {
                    data.showSuperTopicList = data.superTopicList
                }
            }else{
                console.log(res.msg)
            }
        }

        const reqPageData = async () => { //请求页面参数
            const res = await state.util.getJson('/forum/default', 'GET', {}, true);
            if(res.code == 0){
                data.subscribe = res.data.subscribe || false;
                data.latestNews = res.data.latestNews || [];
                data.forum = res.data.forum || {};
                if(res.data.forum_column&&res.data.forum_column.length>0){
                    data.forum_column = res.data.forum_column;
                    state.showcolumnTab =  true;
                }else{
                    data.forum_column = []
                    state.showcolumnTab =  false;
                }
                state.util.reportPageAction('/index/' + data.forum.id);

                setTimeout(() => {
                    if(state.initTabTop < state.scrollRef.getBoundingClientRect().top){
                        state.initTabTop = state.scrollRef.getBoundingClientRect().top;
                    }
                }, 100);
            }else {
                window.Components.toast(res.msg)
            }
        };

        const reqSubsection = async () => { //请求圈子的分类
            const res = await state.util.getJson('/forum/subsection', 'GET', {forum_id: data.forum.id}, true);
            if(res.code == 0){
                let lin = {name: "综合", id: 0};
                data.subsection = [lin, ...res.data];

                state.addForumTypeList.map(item => {
                    item.isUse = false;
                })

                res.data.map((v) => {
                    if(v.name == '问答' && v.allow_post == 1){
                        state.addForumTypeList.map(item => {
                            if(item.type == 'questions'){
                                item.isUse = true;
                            }
                        })
                    }else if(!['问答', '视频'].includes(v.name) && v.allow_post == 1){
                        state.addForumTypeList.map(item => {
                            if(item.type == 'forum'){
                                item.isUse = true;
                            }
                        })
                    }
                })
            }else {
                window.Components.toast(res.msg)
            }
        };

        const reqPopup = async () => {  //请求弹窗的数据
            const res = await state.util.getJson('/popup', 'GET', {}, true);
            if(res.code == 0){

            }else {
                window.Components.toast(res.msg)
            }
        }

        const reqForumList = async (flag = false) => { //请求帖子列表
            let params = {}
            if(state.selectedOption == 'new') {
                params = {
                    forum_id: data.forum.id,
                    page: state.page,
                    per_page: state.limit
                }
            }else {
                params = {
                    forum_id: data.forum.id,
                    page: state.page,
                    per_page: state.limit,
                    order_heat: ''
                }
            }

            if( data?.subsection?.[state.active]?.id && data.subsection[state.active].id != 0){
                params.sub_forum_id = data.subsection[state.active].id;
            }

            const res = await state.util.getJson('/thread', 'GET', params, true);
            if(res.code == 0){
                if(flag){ //加载更多
                    data.forumList.push(...res.data.thread);
                }else{ //刷新
                    data.forumList = res.data.thread;
                }
                const list = data.forumList;
                const videoIdList = [];
                for (const element of list) {
                    if(element.video) {
                        videoIdList.push(element.video);
                    }
                }
                const videoRes = await state.util.getVideoInfo(videoIdList);
                if(videoRes.code == 0) {
                    for (let index = 0; index < list.length; index++) {
                        for (const elementVideoRes of videoRes.data) {
                            if (data.forumList[index].video === elementVideoRes.asset_id) {
                                data.forumList[index].cover_url = elementVideoRes.cover_url;
                                data.forumList[index].video_url = elementVideoRes.video_url;
                                break;
                            }
                        }
                    }
                }
                state.page += 1;
                if(res.data.total > 1){
                    state.total = res.data.total;
                };
                if(flag) {
                    setTimeout(() => {
                        state.isLoad = false;
                    }, 400)
                }
            }else {
                window.Components.toast(res.msg)
            }
        };

        const reqInterestList = async () => { //获取全部圈子的信息
            const res = await state.util.getJson('/forum/all', 'GET', {}, true);
            if(res.code == 0){
                let newArr = []
                data.interestList = res.data;
                data.interestList.recommend_bbs.map(item => {
                    item.isSelect = true;
                })
                data.interestList.bbs.map(item => {
                    item.bbs.map(item2 => {
                        newArr.push(item2)
                    })
                })
                data.allThreadList = newArr;
                data.threadList = newArr;
                data.allThreadList.map(item => {
                    item.isSelect = true;
                })
            }else {
                window.Components.toast(res.msg)
            }
        };

        const initAllInterestScroll = () => { //打开全部圈子列表
            state.allInterestBs = new BScroll('.list',{
                scrollY: true,
                click: true,
                probeType: 1,
                bounceTime: 400,
                outOfBoundaryDampingFactor: 0.2,
                specifiedIndexAsContent: 0,
                bindToWrapper: true,
                stopPropagation: true
            });
        };

        const reqNewsList = async () => { //获取更多资讯
            const params = {
                forum_id: data.forum.id,
                page: 1,
            }
            const res = await state.util.getJson('/news', 'GET', params, true);
            if(res.code == 0){
                data.newsList = res.data.latest_news;
            }else {
                window.Components.toast(res.msg)
            }
        };

        const initMoreNewsScroll = () => { //打开全部圈子列表
            state.moreNewsBs = new BScroll('.new_more_list',{
                scrollY: true,
                click: true,
                probeType: 3,
                bounceTime: 400,
                outOfBoundaryDampingFactor: 0.2,
                specifiedIndexAsContent: 0,
                bindToWrapper: true,
                stopPropagation: true
            })
        };

        const reqCircleData = async(id = data.forum.id) => { //请求指定圈子
            const res = await state.util.getJson('/forum/home', 'GET', {forum_id: id}, true);
            if(res.code == 0){
                data.subscribe = res.data.subscribe || false;
                data.latestNews = res.data.latestNews || [];
                data.forum = res.data.forum || {};
                if(res.data.forum_column&&res.data.forum_column.length>0){
                    data.forum_column = res.data.forum_column;
                    state.showcolumnTab =  true;
                }else{
                    data.forum_column = []
                    state.showcolumnTab =  false;
                }
            }else {
                window.Components.toast(res.msg);
            }

            state.util.reportPageAction('/index/' + id);
        };

        const changeList = async () => { //局部刷新数据
            let params = {}
            if(state.selectedOption == 'new') {
                params = {
                    forum_id: data.forum.id,
                    page: 1,
                    per_page: state.limit * (state.page - 1 < 1 ? 1 : state.page - 1),
                }
            }else {
                params = {
                    forum_id: data.forum.id,
                    page: 1,
                    per_page: state.limit * (state.page - 1 < 1 ? 1 : state.page - 1),
                    order_heat: ''
                }
            }

            if(data.subsection[state.active].id != 0){
                params.sub_forum_id = data.subsection[state.active].id;
            }

            const res = await state.util.getJson('/thread', 'GET', params, true);
            if(res.code == 0){
                data.forumList = res.data.thread;
                state.total = res.data.total;
                const list = data.forumList;
                const videoIdList = [];
                for (const element of list) {
                    if(element.video) {
                        videoIdList.push(element.video);
                    }
                }
                const videoRes = await state.util.getVideoInfo(videoIdList);
                if(videoRes.code == 0) {
                    for (let index = 0; index < list.length; index++) {
                        for (const elementVideoRes of videoRes.data) {
                            if (data.forumList[index].video === elementVideoRes.asset_id) {
                                data.forumList[index].cover_url = elementVideoRes.cover_url;
                                data.forumList[index].video_url = elementVideoRes.video_url;
                                break;
                            }
                        }
                    }
                }
            }else {
                window.Components.toast(res.msg)
            }
        }

        const reqDelete = async (params) => { //删除主题
            const res = await state.util.getJson('/thread/delete', 'POST', params, true);

            if(res.code == 0){
                window.Components.toast('删除成功');
                await changeList();
            }else {
                window.Components.toast(res.msg)
            }
        };

        const reqShamPraise = async (params) => { //虚假更新点赞
            data.forumList.forEach((item,index) => {
                if(item.tid == params.tid){
                    data.forumList[index].user_like = params.status
                    if(data.forumList[index].user_like == 1){
                        data.forumList[index].likes += 1
                    }else{
                        data.forumList[index].likes -= 1
                    }
                }
            });
        };

        const reqActivityList = async() => { //请求活动列表
            const res = await state.util.getJson2('/vip/v1/activity_list', 'GET', { position: 'moment_activity' }, true);
            if(res.code == 0){
                let activityList = [];
                if(data.forum.id) {
                    res.data.list.map(item => {
                        if(item.forum_id == data.forum.id) {
                            activityList.push(item);
                        }
                    })
                    data.activityList = activityList;
                }else {
                    data.activityList = res.data.list;
                }
            }else {
                window.Components.toast(res.message)
            }
        };

        const reqAdvertise = async () => { //获取开屏弹窗信息
            //先拿出缓存里面的值，判断这个用户(今天)是否(点击)了ifcheckbox，弹窗
            state.ifCheckbox = await methods.getUserConfiguration('ifCheckbox')
            //不同的日子的时候，弹窗
            if(await methods.getUserConfiguration('date') != state.util.getYMD()){
                state.ifCheckbox = false
                methods.setUserConfiguration({ifCheckbox:state.ifCheckbox,date:state.util.getYMD()})
            }
            const res = await state.util.getJson('/popup', 'GET', {}, true);
            if(res.code == 0){
                data.advertiseData = res.data;
            }else {
                window.Components.toast(res.msg)
            }

            if(JSON.stringify(data.advertiseData) !== '{}' && methods.getTimeMiddle(data.advertiseData && data.advertiseData.started_at, data.advertiseData && data.advertiseData.ended_at)){
                //第二个情况,有数据而且弹窗
                if(!state.ifCheckbox){
                    state.showAdvertise = true;
                }
                //第三个情况,有数据但是选中了下次不弹窗，不弹窗
                else{
                    state.showAdvertise = false;
                }
            }else{
                //第一个情况：数据为空，不弹窗
                state.showAdvertise = false;
            }
        };

        const getPopList = async () => {
            //请求开屏弹窗信息
            const res = await state.util.getJson('/benefit/popUpList', 'GET', {position: 2}, true);
            if(res.code == 0) {
                data.popupList = res.data
                //已打开弹窗的圈子不再打开
                data.selectForumIdArr.map(item => {
                    if(item == data.forum.id) {
                        data.popupList = [];
                    }
                })
                if(data.popupList && data.popupList.length > 0) {
                    //只获取当前选中圈子的弹窗列表
                    data.popupList = data.popupList.filter(item => item.forum_id == data.forum.id)
                    state.screenPopup = true
                }
                //把已打开弹窗的圈子id存进数组
                if(!data.selectForumIdArr.includes(data.forum.id)) {
                    data.selectForumIdArr.push(data.forum.id)
                }
            }else{
                console.log(res.msg)
            }
        }

        const methods = { //方法库, 需要暴露出去的方法放在这里
            bgHandle: (color) => { //顶部导航栏背景颜色处理，把rgb(0,0,0) 转化成 0,0,0
                if(color){
                    return color.substr(4, color.length - 5)
                }else{
                    return '0,0,0'
                }
            },
            setExpanded: (isExpanded) => {
                state.isExpanded = isExpanded
                initPageView();
                setTimeout(() => {
                    state.initTabTop = state.headRef.offsetHeight + state.infoRef.offsetHeight;
                    state.toolBgHeight = state.initTabTop + 28;
                }, 0)
                setTimeout(() => {
                    if (state.bs) {
                        state.bs.refresh()
                    }
                }, 500)
            },
            clickStat: (params) => {
                const { id: post_id = '', is_announce = '1'} = params;
                state.util.clickStat('circle_click_post', {post_id, is_announce});
            },
            enterStat: () => {
                const { id: circle_id = ''} = data.forum;
                const { name: circle_name = ''} = data.forum;
                state.util.enterStat('enter_social_circle_tab', {circle_id, circle_name});
            },
            interestListShowPop: () => { //显示全部圈子弹窗
                reqInterestList();
                state.showInterestPop = true;
                setTimeout(() => {
                    initAllInterestScroll();
                    state.allInterestBs.refresh();
                }, 100);
            },
            hideInterestPop: () => { //关闭全部圈子弹窗
                state.showInterestPop = false;
                setTimeout(() => {
                    state.allInterestBs.scrollTo(0, 0);
                    state.allInterestBs.destroy();
                }, 100);
            },
            showNewsListPop: () => { //打开更多资讯弹窗
                reqNewsList();
                state.showMoreNewsPop = true;
                setTimeout(() => {
                    initMoreNewsScroll();
                    state.moreNewsBs.refresh()
                }, 100);
            },
            hideNewsListPop: () => { //关闭更多资讯弹窗
                state.showMoreNewsPop = false;
                state.moreNewsBs.destroy();
            },
            followForum: async () => { //关注/取关
                if (!state.util.getCookieLocalStorage('access_token')) {
                    state.util.login({ query: { routerurl: router?.options?.history?.state?.current } }, 'replace')
                    return false;
                }
                if(!state.isClickFollowForum){
                    return;
                }
                state.isClickFollowForum = false
                const params = {
                    forum_id: data.forum.id
                }
                const res = await state.util.getJson(data.subscribe ? '/forum/unsubscribe' : '/forum/subscribe', 'POST', params, true);
                if(res.code == 0){
                    window.Components.toast((data.subscribe ? '取消': '') + '关注成功')
                    await reqCircleData();
                    state.isClickFollowForum = true
                }else {
                    window.Components.toast(res.msg)
                }
            },
            switchCircle: async (id) => { //切换圈子
                if(id == data.forum.id){
                    window.Components.toast('当前圈子已选中')
                    return false;
                };
                state.page= 1;
                state.total= 1;
                await reqCircleData(id);
                await reqSubsection();
                await reqActivityList();
                await getSuperTopic();
                // methods.hideInterestPop();
                state.initTabTop = '';
                initPageView()
                state.bs.scrollTo(0, 0);
                await reqForumList();
                setTimeout(() => {
                    state.initTabTop = state.headRef.offsetHeight + state.infoRef.offsetHeight;
                    state.toolBgHeight = state.initTabTop + 28;
                }, 100);
            },
            childrenTabChange: async (current) => { //子版块切换
                state.page= 1;
                state.total= 1;
                const { id: column_id = '', name: column_name = '' } = data?.subsection?.[state.active] || {};
                state.util.clickStat('circle_click_column', { column_id, column_name });
                await reqForumList();
                // state.bs.scrollTo(0, state.headRef.offsetHeight - state.initTabTop);
            },
            goState: (o) => { //跳转路由
                router.push(o);
            },
            goLike: async (o) => {//点赞事件
                const res = await state.util.getJson('/thread/like', 'POST', o, true);
                if(res.code == 0){
                    await reqShamPraise(o);
                    setTimeout(() => {
                        state.bs.refresh();
                    }, 300);
                }else {
                    window.Components.toast(res.msg)
                }
            },
            imgLoadFun: () => { //图片加载完毕，刷新滚动条
                state.bs.refresh();
            },
            deleteForum: (params) => {
                Dialog.confirm({
                    title: '删除主题',
                    message: '是否确定删除此主题',
                })
                .then(() => {
                    reqDelete(params);
                })
                .catch(() => {});
            },
            computerShowEditForum: () => {
                for(let i in state.addForumTypeList){
                    if(state.addForumTypeList[i].isUse){
                        return true;
                    }
                };

                return false;
            },
            checkbox: (value) => {
                state.ifCheckbox = value;
                methods.setUserConfiguration({ifCheckbox:state.ifCheckbox,date:state.util.getYMD()})
            },
            HaveAdvertise: (value)=>{
                state.showAdvertise = value;
            },
            setUserConfiguration: (obj)=>{
                state.util.setUserConfiguration(obj)
            },
            getUserConfiguration: (name)=>{
                return state.util.getUserConfiguration(name)
            },
            getTimeMiddle: (sTime,oTime) => {
                //判断时间是否在开始时间和结束时间内
                if(sTime && oTime){
                    let startTime = state.util.getTimeFormat(sTime);
                    let overTime = state.util.getTimeFormat(oTime);
                    let nowTime = Date.now();

                    if (startTime <= nowTime && nowTime <= overTime){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            },
            jumpPage: (item) => {
                //点击工具栏某个图标进行跳转
                if(item.jump_type == 1) {
                    methods.goState({name: 'iframe-view', query: {url: item.link, name: router.currentRoute.value.name}})
                }
                if(item.jump_type == 2) {
                    state.util.winOpen(item.link);
                }
                if(item.jump_type == 3) {
                    //盒子内跳转
                    const linkArr = item.link.split('?')
                    let query = {}
                    if(linkArr.length > 1) {
                        //对传值进行分解
                        const queryArr = linkArr[1].split('&')
                        queryArr.map(queryItem => {
                            query[queryItem.split('=')[0]] = queryItem.split('=')[1]
                        })
                    }
                    methods.goState({path: `${linkArr[0]}`, query});
                }
            },
            goTop: () => {
                state.bs.scrollTo(0, 0, 0);
                state.toolBgDistance = 0;
            },
            closeSelectGamePopup: () => { //关闭确认订单
                state.isShowSelectGamePopup = false;
                let list = [];
                data.allThreadList.map(item => {
                    if(item.isSelect) {
                        list.push(item);
                    }
                })
                data.threadList = list;
                // let isClear = true;
                // state.currentGameList.forEach(item => {
                //     if(item.game_id === state.currentGame.game_id){
                //         isClear = false;
                //     }
                // });
                // if(isClear){
                //     state.currentGame = {}
                // }
                // if (isClear && state.currentGameList.length > 0) {
                //     methods.changeCurrentGame(state.currentGameList[0])
                // }
            },
            selectGame: async (params,idx) => {
                if(data.allThreadList.length > 0){
                    for (let index = 0; index < data.allThreadList.length; index++) {
                        const item = data.allThreadList[index];
                        if(item.id == params.id){
                            data.allThreadList[idx].isSelect = !params.isSelect
                            return;
                        }
                    }
                }
            },
            handleCLickActivity: (params) => {
                // 获取参数
                const access_token = state.util.Cookie().get("access_token") || '';
                const { game_id } = state.util.getStatInfo() || {};
                const username = state.userInfo.username || '';

                // 拼接参数到URL
                let url = params.link;
                url += url.indexOf('?') > -1 ? '&' : '?';
                url += `access_token=${access_token}&game_id=0&username=${username}`;

                if(params.jump_type == 1) {
                    methods.goState({name: 'iframe-view', query: {url: url, name: router.currentRoute.value.name}})
                }
                if(params.jump_type == 2) {
                    state.util.winOpen(url);
                }
                if(params.jump_type == 3) {
                    //盒子内跳转
                    const linkArr = params.link.split('?')
                    let query = {}
                    if(linkArr.length > 1) {
                        //对传值进行分解
                        const queryArr = linkArr[1].split('&')
                        queryArr.map(queryItem => {
                            query[queryItem.split('=')[0]] = queryItem.split('=')[1]
                        })
                    }
                    methods.goState({path: `${linkArr[0]}`, query});
                }
            },
            sortSelectChange: async () => {
                state.page= 1;
                state.total= 1;
                await reqForumList();
            },
            goTopicPage: async (item) => {
                methods.goState({name: 'superTopic', query: {id: item.id}})
            },
            expandSuperTopic: () => {
                // data.showSuperTopicList = data.superTopicList
                methods.goState({name: 'moreSuperTopic', query: {id: data.forum.id}})
            },
            goSearchPage: () => {
                if (!state.util.getCookieLocalStorage('access_token')) {
                    state.util.login({ query: { routerurl: router?.options?.history?.state?.current } }, 'replace')
                    return false;
                }
                methods.goState({name: 'searchPage', query: {id: data.forum.id}})
            },
            closeActivityPop() {
                //关闭活动弹窗
                state.screenPopup = false
            },
            handleTouchStart2: (event) => {
                state.touchStartTime = new Date().getTime();
                state.touchStartX = event.touches[0].clientX;
                state.touchStartY = event.touches[0].clientY;
            },

            handleTouchMove2: (event) => {
                // 阻止默认行为防止滑动冲突
                event.preventDefault();
            },

            handleTouchEnd2: async (event, item) => {
                const touchEndTime = new Date().getTime();
                const touchEndX = event.changedTouches[0].clientX;
                const touchEndY = event.changedTouches[0].clientY;

                // 计算时间差和位移
                const timeGap = touchEndTime - state.touchStartTime;
                const moveX = touchEndX - state.touchStartX;
                const moveY = Math.abs(touchEndY - state.touchStartY);

                if (moveX > 140) {
                    if(state.active > 0) {
                        state.page= 1;
                        state.total= 1;
                        state.active = Number(state.active) - 1
                        await reqForumList()
                    }
                }

                if(moveX < -140) {
                    if(state.active < data.subsection.length - 1) {
                        state.page= 1;
                        state.total= 1;
                        state.active = Number(state.active) + 1
                        await reqForumList()
                    }
                }
            },
        };

        onBeforeRouteLeave((to, from) => {
            if(state.util.leaveIntercept(to)) return true; else return false;
        });

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods,
        };
    },
});
</script>

<style lang="less" scoped>
@charset "utf-8";
@import "@/assets/less/common/index.less";
</style>
